<template>
    <div>
        <!-- section start -->
        <section>
            <div class="inner row3_1 flex mobileFlexCol">
                <article class="wd50">
                    <div class="aRow3 trendSection1">
                        <h1>시니어산업 <br class="mobileBlock"> 글로벌 트렌드</h1>
                        <div class="alignR gtrendImgBox mobileBlock">
                            <figure>
                                <img src="../../assets/images/cmmnMain/New 글로벌트렌드 이미지.png" alt="글로벌트렌드이미지">
                            </figure>
                        </div>
                        <p>
                            시니어산업은 전세계적으로 유망산업으로 전망되고 있으며, 해외 리더 기업들의 적극적인 참여가 이루어지고 있습니다. <br class="mobileNotBr">
                            유럽, 미국 등의 해외에서 전체 GDP 규모의 절반이상을 차지할 것으로 전망되며, 아시아에서도 시니어산업의 규모는
                            세 번째로 큰 시장에 도달하였습니다.
                        </p>
                        <!-- 요청에 의한 삭제 대기 -->
                        <div class="rowBtn2">
                            <a class="mainBgBtn btnFont" href="https://newagingplatform.com/about/platform" target="_blank">시작하기</a>
                        </div>
                    </div>
                </article>
                <article class="wd50 mobileReset">
                    <div class="alignR gtrendImgBox">
                        <figure>
                            <img src="../../assets/images/cmmnMain/New 글로벌트렌드 이미지.png" alt="글로벌트렌드이미지">
                        </figure>
                    </div>
                </article>
            </div>
        </section>
        
        <section>
            <div class="inner row2">
                <h1 class="mainTitle">시니어산업<br class="mobileBr"> 기업 네트워킹의 필요성</h1>
                <article class="aRow4_1 flex mobileReset">
                    <div class="wd33">
                        <figure>
                            <img src="../../assets/images/cmmnMain/고령친화산업성장전략.png" alt="고령친화산업 이미지">
                            <figcaption>시니어산업<br class="mobileBr"> 성장전략</figcaption>
                        </figure>
                    </div>
                    <div class="wd33">
                        <figure>
                            <img src="../../assets/images/cmmnMain/새로운혁신.png" alt="새로운혁신 이미지">
                            <figcaption>새로운 혁신</figcaption>
                        </figure>
                    </div>
                    <div class="wd33">
                        <figure>
                            <img src="../../assets/images/cmmnMain/맞춤형서비스제공.png" alt="맞춤형서비스제공 이미지">
                            <figcaption>맞춤형 서비스 제공</figcaption>
                        </figure>
                    </div>
                </article>
                <article class="mobileBlock">
                    <div class="mobileDistance">
                        <VueSlickCarousel v-bind="settings">
                            <div class="wd33">
                                <figure>
                                    <img src="../../assets/images/cmmnMain/고령친화산업성장전략.png" alt="고령친화산업 이미지">
                                    <figcaption>시니어산업<br class="mobileBr"> 성장전략</figcaption>
                                </figure>
                            </div>
                            <div class="wd33">
                                <figure>
                                    <img src="../../assets/images/cmmnMain/새로운혁신.png" alt="새로운혁신 이미지">
                                    <figcaption>새로운 혁신</figcaption>
                                </figure>
                            </div>
                            <div class="wd33">
                                <figure class="addPd">
                                    <img src="../../assets/images/cmmnMain/맞춤형서비스제공.png" alt="맞춤형서비스제공 이미지">
                                    <figcaption>맞춤형 서비스 제공</figcaption>
                                </figure>
                            </div>
                        </VueSlickCarousel>
                    </div>
                </article>
            </div>
        </section>

        <section>
            <div class="inner row2 mobileDistance">
                <h1 class="mainTitle">성장전략 해외동향 (1) <br class="mobileBr"> 고령소비자</h1>
                <article class="aRow2">
                    <h3 class="alignC">
                        고령친화 B2C 사례
                    </h3>
                    <section class="flex mobileReset b2cCase">
                        <div class="b2cCaseItem">
                            <figure class="nation">
                                <img src="../../assets/images/cmmnMain/globaltrend/미국국기.png" alt="미국 국기">
                                <figcaption>미 국</figcaption>
                            </figure>
                            <div class="txtBox">
                                <h4>
                                    인스타 카트
                                </h4>
                                <p>
                                    고객욕구에 맞는 쇼핑서비스
                                </p>
                            </div>
                        </div>
                        <div class="b2cCaseItem">
                            <figure class="nation">
                                <img src="../../assets/images/cmmnMain/globaltrend/독일국기.png" alt="독일 국기">
                                <figcaption>독 일</figcaption>
                            </figure>
                            <div class="txtBox">
                                <h4>
                                    슈티프퉁 바렌테스트
                                </h4>
                                <p>
                                    고령친화복지용구 및 서비스에 대한 통합정보제공
                                </p>
                            </div>
                        </div>
                        <div class="b2cCaseItem">
                            <figure class="nation">
                                <img src="../../assets/images/cmmnMain/globaltrend/일본국기.png" alt="일본 국기">
                                <figcaption>일 본</figcaption>
                            </figure>
                            <div class="txtBox">
                                <h4>
                                    이온 백화점
                                </h4>
                                <p>
                                    고령친화적 오프라인 유통매장
                                </p>
                            </div>
                        </div>
                        <div class="b2cCaseItem">
                            <figure class="nation">
                                <img src="../../assets/images/cmmnMain/globaltrend/중국국기.png" alt="중국 국기">
                                <figcaption>중 국</figcaption>
                            </figure>
                            <div class="txtBox">
                                <h4>
                                    허마센셩
                                </h4>
                                <p>
                                    온·오프라인 소비채널 융합 시니어 접근기업
                                </p>
                            </div>
                        </div>
                    </section>
                    <section class="mobileBlock">
                        <div class="mobileDistance b2cCase">
                            <VueSlickCarousel v-bind="settings">
                                <div class="b2cCaseItem">
                                    <figure class="nation">
                                        <img src="../../assets/images/cmmnMain/globaltrend/미국국기.png" alt="미국 국기">
                                        <figcaption>미 국</figcaption>
                                    </figure>
                                    <div class="txtBox">
                                        <h4>
                                            인스타 카트
                                        </h4>
                                        <p>
                                            고객욕구에 맞는<br> 쇼핑서비스
                                        </p>
                                    </div>
                                </div>
                                <div class="b2cCaseItem">
                                    <figure class="nation">
                                        <img src="../../assets/images/cmmnMain/globaltrend/독일국기.png" alt="독일 국기">
                                        <figcaption>독 일</figcaption>
                                    </figure>
                                    <div class="txtBox">
                                        <h4>
                                            슈티프퉁 바렌테스트
                                        </h4>
                                        <p>
                                            고령친화복지용구 및<br> 서비스에 대한<br> 통합정보제공
                                        </p>
                                    </div>
                                </div>
                                <div class="b2cCaseItem">
                                    <figure class="nation">
                                        <img src="../../assets/images/cmmnMain/globaltrend/일본국기.png" alt="일본 국기">
                                        <figcaption>일 본</figcaption>
                                    </figure>
                                    <div class="txtBox">
                                        <h4>
                                            이온 백화점
                                        </h4>
                                        <p>
                                            고령친화적 오프라인<br> 유통매장
                                        </p>
                                    </div>
                                </div>
                                <div class="b2cCaseItem">
                                    <figure class="nation">
                                        <img src="../../assets/images/cmmnMain/globaltrend/중국국기.png" alt="중국 국기">
                                        <figcaption>중 국</figcaption>
                                    </figure>
                                    <div class="txtBox">
                                        <h4>
                                            허마센셩
                                        </h4>
                                        <p>
                                            온·오프라인 소비채널<br> 융합 시니어 접근기업
                                        </p>
                                    </div>
                                </div>
                            </VueSlickCarousel>
                        </div>
                    </section>
                </article>
                <article class="aRow4_2">
                    <h3 class="alignC">
                        디지털 격차 해소 프로그램 글로벌 사례
                    </h3>
                    <section class="flex mobileReset b2cCase">
                        <div class="b2cCaseItem">
                            <figure class="nation">
                                <img src="../../assets/images/cmmnMain/globaltrend/영국 국기.png" alt="영국 국기">
                                <figcaption>영 국</figcaption>
                            </figure>
                            <div class="txtBox">
                                <p>
                                    건강 및 복지분야 <br>
                                    종사자 대상 돌봄 <br>
                                    서비스 디지털 교육 <br>
                                    제공
                                </p>
                            </div>
                        </div>
                        <div class="b2cCaseItem">
                            <figure class="nation">
                                <img src="../../assets/images/cmmnMain/globaltrend/호주 국기.png" alt="호주 국기">
                                <figcaption>호 주</figcaption>
                            </figure>
                            <div class="txtBox">
                                <p>
                                    50세 이상 시니어에게 디지털 교육 제공
                                </p>
                            </div>
                        </div>
                        <div class="b2cCaseItem">
                            <figure class="nation">
                                <img src="../../assets/images/cmmnMain/globaltrend/미국국기.png" alt="미국 국기">
                                <figcaption>미 국</figcaption>
                            </figure>
                            <div class="txtBox">
                                <p>
                                    SNS 활동으로 건강·경제·구직 등 기술
                                    접근지원
                                </p>
                            </div>
                        </div>
                        <div class="b2cCaseItem">
                            <figure class="nation">
                                <img src="../../assets/images/cmmnMain/globaltrend/독일국기.png" alt="독일 국기">
                                <figcaption>독 일</figcaption>
                            </figure>
                            <div class="txtBox">
                                <p>
                                    컴퓨터 등 기술접근을 <br> 원하는 시니어에게 <br>
                                    교육제공
                                </p>
                            </div>
                        </div>
                    </section>
                    <section class="mobileBlock">
                        <div class="mobileDistance b2cCase">
                            <VueSlickCarousel v-bind="settings">
                                <div class="b2cCaseItem">
                                    <figure class="nation">
                                        <img src="../../assets/images/cmmnMain/globaltrend/영국 국기.png" alt="영국 국기">
                                        <figcaption>영 국</figcaption>
                                    </figure>
                                    <div class="txtBox">
                                        <p>
                                            건강 및 복지분야 <br>
                                            종사자 대상 돌봄 <br>
                                            서비스 디지털 교육 <br>
                                            제공
                                        </p>
                                    </div>
                                </div>
                                <div class="b2cCaseItem">
                                    <figure class="nation">
                                        <img src="../../assets/images/cmmnMain/globaltrend/호주 국기.png" alt="호주 국기">
                                        <figcaption>호 주</figcaption>
                                    </figure>
                                    <div class="txtBox">
                                        <p>
                                            50세 이상 시니어에게 <br> 디지털 교육 제공
                                        </p>
                                    </div>
                                </div>
                                <div class="b2cCaseItem">
                                    <figure class="nation">
                                        <img src="../../assets/images/cmmnMain/globaltrend/미국국기.png" alt="미국 국기">
                                        <figcaption>미 국</figcaption>
                                    </figure>
                                    <div class="txtBox">
                                        <p>
                                            SNS 활동으로 <br> 건강·경제·구직 등 <br> 기술
                                            접근지원
                                        </p>
                                    </div>
                                </div>
                                <div class="b2cCaseItem">
                                    <figure class="nation">
                                        <img src="../../assets/images/cmmnMain/globaltrend/독일국기.png" alt="독일 국기">
                                        <figcaption>독 일</figcaption>
                                    </figure>
                                    <div class="txtBox">
                                        <p>
                                            컴퓨터 등 기술접근을<br> 원하는 시니어에게 <br>
                                            교육제공
                                        </p>
                                    </div>
                                </div>
                            </VueSlickCarousel>
                        </div>
                    </section>
                </article>
            </div>
        </section>

        <section>
            <div class="inner row2">
                <h1 class="mainTitle">성장전략 해외동향 (2) <br class="mobileBr"> 고령친화기업</h1>
                <article class="aRow4">
                    <h3 class="alignC">
                        글로벌 리더 기업
                    </h3>
                    <section class="glContainer mobileReset">
                        <div class="globalleaderBox">
                            <div class="amazon">
                                <figure @mouseover="mouseOverAmazon" @mouseout="mouseOutAmazon">
                                    <img src="../../assets/images/cmmnMain/globaltrend/아마존로고.png" alt="아마존 로고">
                                </figure>
                            </div>
                            <div class="apple">
                                <figure @mouseover="mouseOverApple" @mouseout="mouseOutApple">
                                    <img src="../../assets/images/cmmnMain/globaltrend/apple_logo_icon_168588 1.png" alt="애플 로고">
                                </figure>
                            </div>
                            <div class="google">
                                <figure @mouseover="mouseOverGoogle" @mouseout="mouseOutGoogle">
                                    <img src="../../assets/images/cmmnMain/globaltrend/구글로고.png" alt="구글 로고">
                                </figure>
                            </div>
                            <div class="panasonic">
                                <figure @mouseover="mouseOverPanasonic" @mouseout="mouseOutPanasonic">
                                    <img src="../../assets/images/cmmnMain/globaltrend/파나소닉고로.png" alt="파나소닉 로고">
                                </figure>
                            </div>
                        </div>
                        <div class="hexagonBox">
                            <h3 v-show="defaultTxt">
                                기업의 로고에 마우스롤 올려주세요.
                            </h3>
                            <p v-show="amazonActive">
                                <span class="title">
                                    아마존
                                </span>
                                아마존은 글로벌 시니어산업 <br>
                                리더 기업으로 고령자를 위한 플랫폼 <br>
                                기반의 서비스 생태계를 구축함. 대표적인 <br>
                                서비스는 아마존헬스(커넥티트헬스), <br>
                                메디컬웰니스센터(식품&영양), Pill <br>
                                Pack (의약품), Ring(보안), 아마존 <br>
                                프라임(라이프컨시어지), 그리고 <br>
                                Alexa(인공지능기술)이 있음.
                            </p>
                            <p v-show="appleActive">
                                <span class="title">
                                    애 플
                                </span>
                                Apple은 시니어를 위한 <br>
                                기술-서비스 상용화를 위해 <br>
                                AI, 원격기술, 워어러블기기, IoT, <br>
                                빅데이터 등을 활용한 요소기술 <br>
                                개발과 서비스 연계를 위한 <br>
                                노력을 지속하고 있음.
                            </p>
                            <p v-show="googleActive">
                                <span class="title">
                                    구 글
                                </span>
                                구글은 고령화 문제해결을 <br>
                                위한 프로젝트를 진행중이며, <br>
                                헬스케어 웰니스 프로젝트(AI 빅데 <br>
                                이터 기반 건강 서비스), Clico 프로젝트 <br>
                                (노화문제 해결), 커넥티드 홈 프로젝트 <br>
                                (일상생활지원), 그리고 고령자 <br>
                                기술-서비스(핏빗 & 구글홈) <br>
                                개발 등을 포함하고 있음.
                            </p>
                            <p v-show="panasonicActive">
                                <span class="title">
                                    파나소닉
                                </span>
                                파나소닉은 일본 대표 <br>
                                시니어산업 리더기업으로서 <br>
                                개호보험을 중심으로 고령자를 <br>
                                위한 주거공간 사업, 돌봄시설 구축, <br>
                                복지용구를 포함한 시니어를 위한 <br>
                                제품판매 사업과 복지기술 <br>
                                개발을 진행하고 있음.
                            </p>
                        </div>
                    </section>

                    <section class="glContainer mobileBlock">
                        <div class="globalleaderMobileBox">
                            <VueSlickCarousel v-bind="settings">
                                <div class="amazonMobile globalleaderMobileItem">
                                    <figure @mouseover="mouseOverAmazon" @mouseout="mouseOutAmazon">
                                        <img src="../../assets/images/cmmnMain/globaltrend/아마존로고.png" alt="아마존 로고">
                                    </figure>
                                    <p>
                                        <span class="title">
                                            아마존
                                        </span>
                                        아마존은 글로벌 시니어산업
                                        리더 기업으로 고령자를 위한 플랫폼 
                                        기반의 서비스 생태계를 구축함. 대표적인 
                                        서비스는 아마존헬스(커넥티트헬스), 
                                        메디컬웰니스센터(식품&영양), Pill 
                                        Pack (의약품), Ring(보안), 아마존 
                                        프라임(라이프컨시어지), 그리고 
                                        Alexa(인공지능기술)이 있음.
                                    </p>
                                </div>
                                <div class="appleMobile globalleaderMobileItem">
                                    <figure @mouseover="mouseOverApple" @mouseout="mouseOutApple">
                                        <img src="../../assets/images/cmmnMain/globaltrend/apple_logo_icon_168588 1.png" alt="애플 로고">
                                    </figure>
                                    <p>
                                        <span class="title">
                                            애 플
                                        </span>
                                        Apple은 시니어를 위한
                                        기술-서비스 상용화를 위해
                                        AI, 원격기술, 웨어러블기기, IoT,
                                        빅데이터 등을 활용한 요소기술
                                        개발과 서비스 연계를 위한
                                        노력을 지속하고 있음.
                                    </p>
                                </div>
                                <div class="googleMobile globalleaderMobileItem">
                                    <figure @mouseover="mouseOverGoogle" @mouseout="mouseOutGoogle">
                                        <img src="../../assets/images/cmmnMain/globaltrend/구글로고.png" alt="구글 로고">
                                    </figure>
                                    <p>
                                        <span class="title">
                                            구 글
                                        </span>
                                        구글은 고령화 문제해결을
                                        위한 프로젝트를 진행중이며,
                                        헬스케어 웰니스 프로젝트(AI 빅데
                                        이터 기반 건강 서비스), Clico 프로젝트
                                        (노화문제 해결), 커넥티드 홈 프로젝트
                                        (일상생활지원), 그리고 고령자
                                        기술-서비스(핏빗 & 구글홈)
                                        개발 등을 포함하고 있음.
                                    </p>
                                </div>
                                <div class="panasonicMobile globalleaderMobileItem">
                                    <figure @mouseover="mouseOverPanasonic" @mouseout="mouseOutPanasonic">
                                        <img src="../../assets/images/cmmnMain/globaltrend/파나소닉고로.png" alt="파나소닉 로고">
                                    </figure>
                                    <p>
                                        <span class="title">
                                            파나소닉
                                        </span>
                                        파나소닉은 일본 대표
                                        시니어산업 리더기업으로서
                                        개호보험을 중심으로 고령자를
                                        위한 주거공간 사업, 돌봄시설 구축,
                                        복지용구를 포함한 시니어를 위한
                                        제품판매 사업과 복지기술
                                        개발을 진행하고 있음.
                                    </p>
                                </div>
                            </VueSlickCarousel>
                        </div>
                    </section>
                </article>
            </div>
        </section>

        
    </div>   
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    name: 'GlobalTrend',
    components: {
        VueSlickCarousel 
    },
    data() {
        return {
            amazonActive: false,
            appleActive: false,
            googleActive: false,
            panasonicActive: false,
            defaultTxt: true,
            settings: {
                dots:true,
                arrows:false,
                fade:true,
                speed:1500,
                infinite:true,
                autoplay:true,
                autoplaySpeed:5000,
                pauseOnDotsHover:true,
                pauseOnHover:true,
                "responsive": [
                    {
                    "breakpoint": 560,
                    "settings": {
                        "slidesToShow": 1,
                        "slidesToScroll": 1,
                    }
                    },
                ]
            }
        }
    },
    methods: {
        mouseOverAmazon: function() {
            this.amazonActive = true;
            this.defaultTxt = false;
        },
        mouseOutAmazon: function() {
            this.amazonActive = false;
            this.defaultTxt = true;
        },
        mouseOverApple: function() {
            this.appleActive = true;
            this.defaultTxt = false;
        },
        mouseOutApple: function() {
            this.appleActive = false;
            this.defaultTxt = true;
        },
        mouseOverGoogle: function() {
            this.googleActive = true;
            this.defaultTxt = false;
        },
        mouseOutGoogle: function() {
            this.googleActive = false;
            this.defaultTxt = true;
        },
        mouseOverPanasonic: function() {
            this.panasonicActive = true;
            this.defaultTxt = false;
        },
        mouseOutPanasonic: function() {
            this.panasonicActive = false;
            this.defaultTxt = true;
        },
    }
}

</script>

<style scoped>
    .topMenu ul li.active:after {
        content: '';
        position: absolute;
        width: 120%;
        height: 7px;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        background: #26336A;
    }
    a {
        color: #272727;
    }
    a.mainBgBtn {
        color: #FFF;
    }
    h3 {
        margin: 0 0 16px 0;
    }
    .mobileCarousel .slick-slide img {
        margin: 30px auto;
    }
    @media screen and (max-width: 560px) {
        .matchPlaform h3 {
            margin: 0;
        }
        .matchPlaform div p {
            margin: 0 0 20px 0;
        }
    }
</style>

